import { render } from "./ReferenceList.vue?vue&type=template&id=9a5d68b8"
import script from "./ReferenceList.vue?vue&type=script&lang=js"
export * from "./ReferenceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__